import React from 'react'
import { useSelector } from 'react-redux'
import { LanguageUtils, Utils } from '@pbt/pbt-ui-components'

import AccentLabel from '~/components/common/labels/AccentLabel'
import { getInventoryOrderItemShipmentStatus } from '~/store/reducers/constants'

export interface InventoryOrderItemStatusLabelProps {
  statusId: string
}

const InventoryOrderItemStatusLabel = ({
  statusId,
}: InventoryOrderItemStatusLabelProps) => {
  const InventoryOrderItemStatuses = useSelector(
    getInventoryOrderItemShipmentStatus,
  )
  const status = Utils.findById(statusId, InventoryOrderItemStatuses)

  if (!status) {
    return null
  }

  return (
    <AccentLabel
      color={status.color}
      colorVariant={status.colorVariant}
      id={status.id}
      name={LanguageUtils.getTranslatedFieldName(status)}
    />
  )
}

export default InventoryOrderItemStatusLabel
